import Vue from 'vue';

const mutations = {
  SET_SETTING: (state, { key, value }) => {
    Vue.set(state, key, value);
  },
};

export default mutations;
